import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { CoachingCoachMessagesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/messages';
import { markPartnershipConversationRead } from '@efdigital/ll-xceed-v2/utils/coaching/mark-partnership-conversation-read';
import type { PartnershipConversation } from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachMessagesConversationModel = {
  conversation: PartnershipConversation;
  conversations: PartnershipConversation[];
};

export default class CoachingCoachMessagesConversationRoute extends Route<CoachingCoachMessagesConversationModel> {
  @service declare session: SessionService;
  @service declare store: Store;

  model({
    partnership_id,
  }: {
    partnership_id: string;
  }): CoachingCoachMessagesConversationModel {
    const parent = this.modelFor(
      'coaching.coach.messages'
    ) as CoachingCoachMessagesModel;
    const conversation = parent.conversations.find(
      (candidate) => candidate.partnership.id === partnership_id
    );

    if (!conversation) {
      throw new Error(`Conversation not found: ${partnership_id}`);
    }

    return {
      conversation,
      conversations: parent.conversations,
    };
  }

  async afterModel(model: CoachingCoachMessagesConversationModel) {
    await markPartnershipConversationRead(
      model.conversation,
      'coach',
      this.session.cached.userId!,
      this.store
    );
  }
}
